// Esses valores são substituídos durante o build
export const version = {
  commit: 'd0baba2b',
  buildDate: '20250411150255384',
  commitDate: '20250411180139',
};

export class BuildDateFormatter {
  public static formatBuildDate(jenkinsDate: string): string {
    return jenkinsDate.replace(
      /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2}).*/,
      '$3/$2/$1 $4:$5'
    );
  }
}
